module.exports = __webpack_public_path__ + "static/img/2.067da876.png";